import React from 'react';
import styled from 'styled-components';

import { lighten } from 'utils/colours';

import { Slider as AntdSlider } from 'antd';

const prefix = '.ant-slider';
const railClass = `${prefix}-rail`; // background bar
const trackClass = `${prefix}-track`; // part of the bar that is coloured
const handleClass = `${prefix}-handle`; // dot handle
const dotClass = `${prefix}-dot`; // dot indicators shown on given marks

const StyledSlider = styled(AntdSlider)`
    && {
        font-family: ${({ theme }) => theme.font.regular};
    }

    /* RAIL & TRACK */
    && > ${/* sc-selector */ trackClass} {
        background-color: ${({ theme }) => lighten(theme.colour.primary)};
    }
    && > ${/* sc-selector */ railClass} {
        background-color: #f5f5f5; /* default antd colour */
    }

    /* hover effect of rail and track applied on parent hover */
    &:hover {
        && > ${/* sc-selector */ trackClass} {
            background-color: ${({ theme }) => theme.colour.primary};
        }
        && > ${/* sc-selector */ railClass} {
            background-color: #e1e1e1; /* default antd colour */
        }

        && > ${/* sc-selector */ handleClass} {
            &:not(.ant-tooltip-open) {
                border-color: ${({ theme }) => theme.colour.primary};
            }
        }
    }

    /* HANDLE */
    && > ${/* sc-selector */ handleClass} {
        border-color: ${({ theme }) => lighten(theme.colour.primary)};
        background-color: #fff;

        &:focus {
            border-color: ${({ theme }) => lighten(theme.colour.primary)};
            box-shadow: 0 0 0 5px ${({ theme }) => lighten(theme.colour.primary, 30)};
        }
        &.ant-tooltip-open {
            border-color: ${({ theme }) => theme.colour.primary};
        }
    }

    /* DOTS */
    ${/* sc-selector */ dotClass} {
        border-color: #e8e8e8; /* default antd colour */
        background-color: #fff; /* default antd colour */
    }
    ${/* sc-selector */ dotClass}-active {
        border-color: ${({ theme }) => lighten(theme.colour.primary)};
    }
`;

const Slider = ({
    tooltipFormatter = undefined,
    defaultValue = 0,
    step = 1,
    min = 0,
    max = 100,
    onChange = undefined,
    onAfterChange = undefined,
    disabled = false,
    marks = undefined,
}) => (
    <StyledSlider
        defaultValue={defaultValue}
        step={step}
        min={min}
        max={max}
        onChange={onChange}
        onChangeComplete={onAfterChange}
        disabled={disabled}
        marks={marks}
        tooltip={{ formatter: tooltipFormatter }}
    />
);

export default Slider;
